<template>
  <div>
    <div
      class="mb-2"
    >
      <h3
        class="mb-2"
      >
        Template Creative Properties
      </h3>
      <p
        class="mb-0"
      >
        <small>
          Creative properties set here will apply across all articles for the current creative template:
          <strong>
            {{ getActiveCreativeTemplateName }}
          </strong>.
        </small>
      </p>
    </div>
    <section>
      <b-row
        class="gutters-0 align-items-center justify-content-between"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Background Colour
          </p>
        </b-col>
        <b-col
          cols="auto"
        >
          <base-colour-select
            :value="getPropertyValue('backgroundColour')"
            @input="updatePropertyValue('backgroundColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('backgroundColour')"
          />
        </b-col>
      </b-row>
      <hr class="my-4">
    </section>
    <section>
      <h4
        class="mb-3"
      >
        Headline
      </h4>
      <b-row
        class="gutters-0 align-items-center justify-content-between mb-4"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Font Family
          </p>
        </b-col>
        <b-col
          cols="6"
        >
          <base-font-select
            size="sm"
            :value="getPropertyValue('headlineFontFamily')"
            @input="updatePropertyValue('headlineFontFamily', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('headlineFontFamily')"
          />
        </b-col>
      </b-row>
      <b-row
        class="gutters-0 align-items-center justify-content-between mb-4"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Font Size
          </p>
        </b-col>
        <b-col
          cols="6"
        >
          <base-select
            :size="'sm'"
            :options="fontSizeOptions.headline"
            :value="getPropertyValue('headlineFontSize')"
            @change="updatePropertyValue('headlineFontSize', $event.value)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('headlineFontSize')"
          />
        </b-col>
      </b-row>
      <b-row
        class="gutters-0 align-items-center justify-content-between"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Colour
          </p>
        </b-col>
        <b-col
          cols="auto"
        >
          <base-colour-select
            :value="getPropertyValue('headlineFontColour')"
            @input="updatePropertyValue('headlineFontColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('headlineFontColour')"
          />
        </b-col>
      </b-row>
      <hr class="my-4">
    </section>
    <section>
      <h4
        class="mb-3"
      >
        Body Text
      </h4>
      <b-row
        class="gutters-0 align-items-center justify-content-between mb-4"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Font Family
          </p>
        </b-col>
        <b-col
          cols="6"
        >
          <base-font-select
            size="sm"
            :value="getPropertyValue('bodyFontFamily')"
            @input="updatePropertyValue('bodyFontFamily', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('bodyFontFamily')"
          />
        </b-col>
      </b-row>
      <b-row
        class="gutters-0 align-items-center justify-content-between mb-4"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Font Size
          </p>
        </b-col>
        <b-col
          cols="6"
        >
          <base-select
            :size="'sm'"
            :options="fontSizeOptions.body"
            :value="getPropertyValue('bodyFontSize')"
            @change="updatePropertyValue('bodyFontSize', $event.value)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('bodyFontSize')"
          />
        </b-col>
      </b-row>
      <b-row
        class="gutters-0 align-items-center justify-content-between"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Colour
          </p>
        </b-col>
        <b-col
          cols="auto"
        >
          <base-colour-select
            :value="getPropertyValue('bodyFontColour')"
            @input="updatePropertyValue('bodyFontColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('bodyFontColour')"
          />
        </b-col>
      </b-row>
      <hr class="my-4">
    </section>
    <section>
      <h4
        class="mb-3"
      >
        Call to Action
      </h4>
      <b-row
        class="gutters-0 align-items-center justify-content-between mb-4"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Font Family
          </p>
        </b-col>
        <b-col
          cols="6"
        >
          <base-font-select
            size="sm"
            :value="getPropertyValue('ctaFontFamily')"
            @input="updatePropertyValue('ctaFontFamily', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('ctaFontFamily')"
          />
        </b-col>
      </b-row>
      <b-row
        class="gutters-0 align-items-center justify-content-between mb-4"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Font Size
          </p>
        </b-col>
        <b-col
          cols="6"
        >
          <base-select
            :size="'sm'"
            :options="fontSizeOptions.cta"
            :value="getPropertyValue('ctaFontSize')"
            @change="updatePropertyValue('ctaFontSize', $event.value)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('ctaFontSize')"
          />
        </b-col>
      </b-row>
      <b-row
        class="gutters-0 align-items-center justify-content-between mb-4"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Colour
          </p>
        </b-col>
        <b-col
          cols="auto"
        >
          <base-colour-select
            :value="getPropertyValue('ctaFontColour')"
            @input="updatePropertyValue('ctaFontColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('ctaFontColour')"
          />
        </b-col>
      </b-row>
      <b-row
        class="gutters-0 align-items-center justify-content-between"
      >
        <b-col
          cols="auto"
        >
          <p class="mb-0 form-label">
            Background Colour
          </p>
        </b-col>
        <b-col
          cols="auto"
        >
          <base-colour-select
            :value="getPropertyValue('ctaBackgroundColour')"
            @input="updatePropertyValue('ctaBackgroundColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :key="selectedCreativeId"
            :disabled="!canUpdateProperty('ctaBackgroundColour')"
          />
        </b-col>
      </b-row>
      <hr class="my-4">
    </section>
    <section>
      <h4
        class="mb-3"
      >
        Logo
      </h4>
      <logo-upload
        logo-type="unit"
        :key="selectedCreativeId"
      />
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';
import * as templatesTypes from '@/modules/templates/store/types';

import LogoUpload from '@/modules/content/components/CreativesPage/Sidebar/LogoUpload';
import BaseColourSelect from '@/components/BaseColourSelect';
import BaseFontSelect from '@/components/BaseFontSelect';
import BaseSelect from '@/components/BaseSelect';

export default {
  name: 'UnitCreativeProperties',
  components: {
    LogoUpload,
    BaseColourSelect,
    BaseFontSelect,
    BaseSelect,
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
      'order',
      'selectedAdvertiser',
    ]),
    ...mapState('content', [
      'isSidebarInputFocused',
      'selectedCreativeId',
      'feedId',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_READ_ONLY,
      campaignTypes.GET_IS_SELF_SERVICE_CAMPAIGN,
      campaignTypes.GET_IS_CAMPAIGN_REVIEW,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_CURRENT_SELECTED_CREATIVE,
      contentTypes.GET_CURRENT_SELECTED_CREATIVE_PROPERTIES,
      contentTypes.GET_ACTIVE_CREATIVE_TEMPLATES,
      contentTypes.GET_TEMPLATE_NAME_BY_ID,
    ]),
    ...mapGetters('templates', [
      templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES,
    ]),
    getActiveCreativeTemplateName() {
      return this.GET_ACTIVE_CREATIVE_TEMPLATES.find((template) => template.creativeId === this.selectedCreativeId).name;
    },
    fontSizeOptions() {
      return {
        headline: [
          { value: '20', text: '20px' },
          { value: '22', text: '22px' },
          { value: '24', text: '24px' },
          { value: '26', text: '26px' },
          { value: '28', text: '28px' },
          { value: '30', text: '30px' },
        ],
        body: [
          { value: '14', text: '14px' },
          { value: '16', text: '16px' },
          { value: '18', text: '18px' },
          { value: '20', text: '20px' },
        ],
        cta: [
          { value: '12', text: '12px' },
          { value: '14', text: '14px' },
          { value: '16', text: '16px' },
          { value: '18', text: '18px' },
          { value: '20', text: '20px' },
        ],
      };
    },
  },
  methods: {
    ...mapActions('content', [
      contentTypes.PATCH_CREATIVE,
      contentTypes.PATCH_CREATIVE_PROPERTIES,
      contentTypes.TRIGGER_CREATIVE_RERENDER,
      contentTypes.SET_IS_SIDEBAR_INPUT_FOCUSED,
    ]),
    getPropertyValue(property) {
      return this.GET_CURRENT_SELECTED_CREATIVE_PROPERTIES[property];
    },
    async updatePropertyValue(property, value) {
      const creativePayload = {
        advertisersId: this.selectedAdvertiser.id,
        creativeId: this.selectedCreativeId,
        properties: {
          [property]: value,
        },
      };
      await this.PATCH_CREATIVE_PROPERTIES(creativePayload);
      this.TRIGGER_CREATIVE_RERENDER();
    },
    canUpdateProperty(property) {
      return this.GET_IS_SELF_SERVICE_CAMPAIGN
        && !this.GET_IS_READ_ONLY('creative-properties')
        && !this.GET_IS_CAMPAIGN_REVIEW
        && this.GET_TEMPLATE_EDITABLE_PROPERTIES.includes(property);
    },
  },
};
</script>
